import {
  faMicrophone,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import styles from "./RecordButton.module.css";

export const RecordButton = ({
  id,
  onClick,
  dataTestId,
  shouldShowCallMode,
}) => {
  const gradientColors = shouldShowCallMode
    ? "bg-linear-to-br from-green-300 to-green-600 dark:from-green-300 dark:to-green-700"
    : "bg-linear-to-br from-indigo-400 to-indigo-800";

  const hoverColor = shouldShowCallMode
    ? "rgba(34, 197, 94, 0.1)"
    : "rgba(86, 69, 255, 0.1)";

  return (
    <div
      className={`${styles.recordButton} w-3/4 h-3/4 rounded-full cursor-pointer flex text-center relative transition-all ${gradientColors} place-items-center place-content-center focus:outline-hidden shadow-lg`}
      id={id}
      data-testid={dataTestId}
      data-callmode={shouldShowCallMode}
      onClick={onClick}
      style={{
        "--hover-color": hoverColor,
      }}
    >
      <FontAwesomeIcon
        icon={shouldShowCallMode ? faPhone : faMicrophone}
        size="4x"
        color="white"
        className="w-96"
      />
    </div>
  );
};
